var _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 22C28.268 22 22 28.268 22 36V84C22 91.732 28.268 98 36 98H84C91.732 98 98 91.732 98 84V36C98 28.268 91.732 22 84 22H36ZM26 36C26 30.4772 30.4772 26 36 26H84C89.5228 26 94 30.4772 94 36V84C94 89.5228 89.5229 94 84 94H36C30.4772 94 26 89.5229 26 84V36Z",
    fill: "#2D964B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 96,
    r: 12,
    fill: "url(#paint0_linear_3658_56597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1167 95.8019C52.8874 95.531 52.9041 95.1295 53.1551 94.8785L53.6762 94.3573C53.9428 94.0908 54.3749 94.0908 54.6414 94.3573L57.9063 97.6222C57.97 97.6859 58.0723 97.6891 58.1398 97.6295L65.7431 90.9207C66.0133 90.6823 66.4224 90.6951 66.6772 90.9499L66.8449 91.1175C67.1044 91.377 67.1122 91.7953 66.8626 92.0643L58.5435 101.032C58.265 101.332 57.7866 101.321 57.5221 101.008L53.1167 95.8019Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3658_56597",
    x1: 60,
    y1: 84,
    x2: 60,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24893A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFrame);
export default __webpack_public_path__ + "static/media/greenFrame.94e19c1b310e97482672fab86924407c.svg";
export { ForwardRef as ReactComponent };